export enum CorporationNameFields {
  Name = 'name',
}
